/**
 * An explicit "check again", for the queues somebody works through.
 *
 * Focus-refresh covers coming back to the tab; this covers sitting on the
 * page waiting for something to land.
 */
interface Props {
  onClick: () => void;
  busy?: boolean;
  label?: string;
}

export function RefreshButton({ onClick, busy = false, label = "Refresh" }: Props) {
  return (
    <button
      type="button"
      className="btn btn-ghost btn-sm refresh-btn"
      onClick={onClick}
      disabled={busy}
      aria-label={label}
    >
      <span className={`refresh-icon ${busy ? "is-spinning" : ""}`} aria-hidden="true">
        ↻
      </span>
      {busy ? "Checking…" : label}
    </button>
  );
}
